<script setup lang="ts">
import Log from "../Common/Client/Log";
import { onMounted } from "@vue/runtime-core";
import Globals from "./global";
// const token = useCookie("TOKEN", { maxAge: Globals.ONE_YEAR, path: "/", sameSite: "lax" });

const route = useRoute();

function addScript() {
  const scriptElement = document.createElement("script");
  scriptElement.src = "/assets/js/main.js"
  const bodyElement = document.getElementsByTagName("body")[0];
  bodyElement.appendChild(scriptElement);
}

onMounted(()=> {
	setTimeout(addScript, 100);
});

onMounted(() => {
  // token.value = null;
  // if (route.path !== "/")
  // {
  //   redirectToLandingPage();
  //   return;
  // }

  Log.setVersion("0");
  Log.sendLogsEvery10Seconds();
  if (route.query.viref)
    localStorage.setItem("viref", route.query.viref as string);
});

//On land and on navigation change, redirect to landing page
//Landing page should show popup stating the problem

// function redirectToLandingPage(){
//   token.value = null;
//   navigateTo("/");
// }

//Put the () => When it's a string so it's converted into a getter
/*watch(() => route.path, () => {
  if (route.path !== "/")
  redirectToLandingPage();
}, {immediate: true});*/

</script>

<template>
  <div>
    <NuxtLoadingIndicator/>
    <Header />
    <NuxtPage />
    <Footer />
  </div>
</template>
